import script from "./deboniPage.vue?vue&type=script&setup=true&lang=js"
export * from "./deboniPage.vue?vue&type=script&setup=true&lang=js"

import "./deboniPage.vue?vue&type=style&index=0&id=55784eb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55784eb2"]])

export default __exports__